// Lib
import * as Immutable from 'immutable';

// Constants
import { CLOSE_SWITCHER, OPEN_SWITCHER } from './switcherConstants';
import { USER_NAVIGATE } from '../../../common/users/userConstants';
import { MODAL_CLOSE } from '../../components/modal/modalConstants';

const initialState = Immutable.fromJS({
    open: false,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case OPEN_SWITCHER:
            return state.set('open', true);
        case MODAL_CLOSE:
        case USER_NAVIGATE:
        case CLOSE_SWITCHER:
            return state.set('open', false);
        default:
            return state;
    }
};
